import { agroApi } from "../../../../redux/api/api";
import { IFertilizerMarchResponse, IFertilizerMarchParams } from "./types";

export const fertilizerMarchApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getFertilizerMarch: builder.query<IFertilizerMarchResponse, IFertilizerMarchParams>({
      query: ({ year, territorialUnitRegionId }) => ({
        url: "/departments/chemicalization/fertilizer-usage/analytical-data/fertilizer-crop",
        method: "GET",
        params: {
          ...(year && { year }),
          ...(territorialUnitRegionId !== "" && { territorialUnitRegionId })
        }
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetFertilizerMarchQuery } = fertilizerMarchApi;